function initModalButton() {
  $('#kpis-modal-button').on('click', function() {
    $('#kpis-modal-content').html('');
    $('#kpis-modal-loader').show();
    $.ajax({
      url: '/qualification/presales/kpis',
      method: 'GET',
      success: function(data) {
        $('#kpis-modal-content').html(data);
        $('#kpis-modal-loader').hide();
      }
    })
  })
}

window.addEventListener('DOMContentLoaded', initModalButton);
